var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',[_c('router-link',{attrs:{"to":'/managers/users',"tag":"li"}},[_c('a',[_vm._v("Пользователи")])]),_vm._v(" "),_c('router-link',{attrs:{"to":'/managers/settings',"tag":"li"}},[_c('a',[_vm._v("Settings")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3f0a48","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/manager/Menu.vue
// module id = 284
// module chunks = 0